import { render, staticRenderFns } from "./SynchrotronProposalForm.vue?vue&type=template&id=7e06145e&"
import script from "./SynchrotronProposalForm.vue?vue&type=script&lang=js&"
export * from "./SynchrotronProposalForm.vue?vue&type=script&lang=js&"
import style0 from "./SynchrotronProposalForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports